'use client';

import Link from 'next/link';

import { cn, isRouteActive } from '../lib/utils';
import { Trans } from '../makerkit/trans';
import {
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from './sidebar-menu';

type SidebarSubChild = {
  label: string;
  path: string;
  Icon?: React.ReactNode;
  end?: boolean | ((path: string) => boolean);
};

export function SidebarSubItems({
  children,
  currentPath,
  open,
}: {
  children: SidebarSubChild[];
  currentPath: string;
  open: boolean;
}) {
  return (
    <SidebarMenuSub
      className={cn({
        'mx-0 px-1.5': !open,
      })}
    >
      {children.map((child) => {
        const isActive = isRouteActive(child.path, currentPath, child.end);

        const linkClassName = cn('flex items-center', {
          'mx-auto w-full gap-0! [&>svg]:flex-1': !open,
        });

        const spanClassName = cn('w-auto transition-opacity duration-300', {
          'w-0 opacity-0': !open,
        });

        return (
          <SidebarMenuSubItem key={child.path}>
            <SidebarMenuSubButton isActive={isActive} asChild>
              <Link className={linkClassName} href={child.path}>
                {child.Icon}

                <span className={spanClassName}>
                  <Trans i18nKey={child.label} defaults={child.label} />
                </span>
              </Link>
            </SidebarMenuSubButton>
          </SidebarMenuSubItem>
        );
      })}
    </SidebarMenuSub>
  );
}
